import _keyBy from 'lodash/keyBy';

import { getPublicProfiles } from '@homeservices/api-kit/search/publicprofile';
import { createPublicProfile } from '@/transformations/public-profile';

import {
  getOccupations as getServiceCatalogOccupations,
} from '@homeservices/api-kit/servicecatalog/occupations';

export default {
  namespaced: true,
  state () {
    return {
      meta: { fetching: false },
      serviceProviders: {},
      serviceProviderAttributeValues: {},
      serviceProviderOccupations: {},
      serviceCatalogOccupations: {},
      identifiers: {},
    };
  },
  getters: {
    isFetching (state) {
      return state.meta.fetching;
    },
    getRatingCount (state) {
      return Object.values(state.serviceProviderOccupations)
        .reduce((acc, curr) => acc + curr.rating_count, 0);
    },
    getRatingAverage (state, getters) {
      const total = Object.values(state.serviceProviderOccupations)
        .reduce((acc, curr) => acc + (curr.rating_count * curr.rating_average), 0);
      return total / getters.getRatingCount;
    },
    getIdentifiers (state) {
      return state.identifiers;
    },
    serviceProvidersIds ({ serviceProviders }) {
      return Object.keys(serviceProviders);
    },
    serviceProviderOccupationIds ({ serviceProviderOccupations }) {
      return Object.values(serviceProviderOccupations)
        .map(serviceProviderOccupation => serviceProviderOccupation.occupation_id);
    },
    // Merge specific occupation details with generic occupation details
    serviceProviderCatalogOccupations ({ serviceProviderOccupations, serviceCatalogOccupations }) {
      return _keyBy(Object.values(serviceProviderOccupations).map((serviceProviderOccupation) => {
        return {
          ...serviceProviderOccupation,
          occupation: serviceCatalogOccupations[serviceProviderOccupation.occupation_id] || {},
        };
      }), 'id');
    },
    occupationNames ({ serviceCatalogOccupations }) {
      return Object.values(serviceCatalogOccupations)
        .map(catalogOccupation => catalogOccupation.display_name);
    },
  },
  actions: {
    async fetchProProfile ({ commit }, { serviceProviderIdentifer }) {
      const { data } = await getPublicProfiles({
        service_provider_identifiers: serviceProviderIdentifer,
      });
      const occupations = data.results.map(createPublicProfile)
        .filter(p => p.eligible_for_public_profile);

      commit('setIdentifiers', serviceProviderIdentifer);
      commit('setServiceProviderOccupations', _keyBy(occupations, 'id'));
    },
    async fetch ({ commit, dispatch, getters }, { identifiers }) {
      commit('meta', { fetching: true });
      commit('setIdentifiers', identifiers);

      try {
        await dispatch('fetchProProfile', { serviceProviderIdentifer: identifiers });
      } catch (error) {
        commit('meta', { fetching: false });
      }
      await dispatch('fetchServiceCatalogOccupations', getters.serviceProviderOccupationIds);

      commit('meta', { fetching: false });
    },

    async fetchServiceCatalogOccupations ({ commit }, ids) {
      const { data } = await getServiceCatalogOccupations({ occupation_ids: ids.join(',') });
      commit('setServiceCatalogOccupations', _keyBy(data.results, 'id'));
    },
  },
  mutations: {
    meta (state, payload) {
      state.meta = {
        ...state.meta,
        ...payload,
      };
    },
    setProProfile (state, proProfile) {
      state.proProfile = proProfile;
    },
    setServiceProviderOccupations (state, data) {
      state.serviceProviderOccupations = data;
    },
    setServiceCatalogOccupations (state, data) {
      state.serviceCatalogOccupations = data;
    },
    setIdentifiers (state, data) {
      state.identifiers = data;
    },
  },
};
